import { SyntheticEvent, useCallback } from 'react';

import balanceReminderSessionStorage from '@/modules/core/components/Dashboard/components/BalanceReminderBanners/balanceReminderSessionStorage';
import { useHistory } from '@/modules/core/hooks';
import useRevokeQuery from '@/modules/core/queries/useRevoke.query';
import { stopDataDogSession } from '@/utils/config';
import Token from '@/utils/handlers/Token';
import { IS_SSO_TOKEN } from '@/utils/handlers/Token';

import { useAuthStore } from '../stores';

import useAwsAmplifyLogout from './useAwsAmplifyLogout';

const useAuthorization = () => {
  const store = useAuthStore();
  const history = useHistory();
  const { awsAmplifyLogout } = useAwsAmplifyLogout();
  const { handleRevoke } = useRevokeQuery();

  const handleLogout = useCallback(
    async (onSSOLogout?: (() => void) | SyntheticEvent) => {
      const isSsoLogin = localStorage.getItem(IS_SSO_TOKEN);
      balanceReminderSessionStorage.clear();
      const refreshToken = Token.getRefreshToken();
      await handleRevoke({ refresh_token: refreshToken });
      // Close the RUM session while the user is still attached to it.
      stopDataDogSession();
      Token.clear();
      store.setAuth(false);
      store.setIds();
      store.setUser(null);

      if (isSsoLogin) {
        if (typeof onSSOLogout === 'function') {
          onSSOLogout();
        }
        awsAmplifyLogout();
      } else {
        history.push('/');
        if (history?.clear && typeof history?.clear === 'function') {
          history?.clear();
        }

        location.reload();
      }
    },
    [history, store, awsAmplifyLogout, handleRevoke]
  );

  return {
    handleLogout,
  };
};

export default useAuthorization;
